<template>
  <div class="login-container">
    <form class="w3-card w3-twothird w3-padding" action="#" @submit.prevent="reset">
        
        <p>
          <input class="w3-input" 
            type="password" v-model="user.oldPass">
          <label>Old Password</label>
        </p>
        <p>
          <input class="w3-input" 
            type="password" v-model="user.oldPassRepeat">
          <label>Old Password Again</label>
        </p>

        <p>
          <input class="w3-input" 
            type="password" v-model="user.newPass">
          <label>New Password</label>
        </p>

        <button class="w3-button"  type="submit">Log In</button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'userPage',
  data(){
    return {
        user:{
            oldPass:"",
            oldPassRepeat:"",
            newPass:""
        },
        view:{
            oldPassMismatch:false,
            resetSuccessful:false,
            resetFailed: false
        }
    }
  },
  computed:{
      ...mapGetters({userName:'getUserName'})
  },
  methods:{
    ...mapActions({resetPassword:'RESET_USER_PASSWORD'}),
    reset(){
        if(this.user.oldPass !== this.user.oldPassRepeat){
            this.view.oldPassMismatch = true
            console.log("Password Mismatch")
            return 
        }
        console.log("password math")
        console.log(this.oldPass !== this.oldPassRepeat)
        let credentials = {
            login: this.userName,
            pass: this.user.oldPass,
            newPass: this.user.newPass
        }
        this.resetPassword(credentials).then((loginStatus) => {
            if(loginStatus === 'reset OK'){
                this.resetSuccessful = true
                this.resetFailed = false
            } else
            if(loginStatus === 'reset not OK'){
                this.resetFailed = true
                this.resetSuccessful = false
            }
        }).catch((error)=>{
            console.error(error)
        })
    }
  }
}
</script>

<style scoped>

</style>